import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BulletinBoardService } from 'src/app/services/bulletin-board-service/bulletin-board.service';
import { RequestService } from 'src/app/services/request-service/request.service';
import { Ad, Request } from 'npx-family-happy-common';

import { CommonModule } from '@angular/common';
import { HeaderBarComponent } from 'src/app/shared/components/header-bar/header-bar.component';
import { MyDatePipe } from 'src/app/date.pipe';
import { ModalLoaderComponent } from 'src/app/shared/components/modal-loader/modal-loader.component';
import { CookieBannerComponent } from 'src/app/shared/components/cookie-banner/cookie-banner.component';

@Component({
  selector: 'app-request-detail',
  templateUrl: './request-detail.component.html',
  styleUrls: ['./request-detail.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    HeaderBarComponent,
    MyDatePipe,
    ReactiveFormsModule,
    ModalLoaderComponent,
    CookieBannerComponent,
  ],
})
export class RequestDetailComponent implements OnInit {
  ad!: Ad;
  requestID!: string;
  request!: Request;
  notCandidable!: boolean;
  isDangerous!: boolean;
  modalLoader = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private boardService: BulletinBoardService,
    private requestService: RequestService,
  ) {}

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.requestID = params.get('id') ?? '';

      if (this.requestID) {
        this.boardService.getAdById(+this.requestID).subscribe((req: any) => {
          this.ad = req;
        });
      }
    });

    this.requestService.getRequest(this.requestID).subscribe((req: any) => {
      this.request = req[0];
    });
  }
}
